export class WebSocketMetric {
    /** Installation Name */
    installationName: string = "";

    /** Byte Sent */
    byteSent: number = 0;

    /** Byte Received */
    byteReceived: number = 0;

    /** Date time */
    dateTime: Date = null;

    constructor() {}

    public parse(obj: any) {
        if (obj.InstallationName) this.installationName = obj.InstallationName;
        if (obj.ByteSent) this.byteSent = obj.ByteSent;
        if (obj.ByteReceived) this.byteReceived = obj.ByteReceived;
        if (obj.DateTime) this.dateTime = obj.DateTime;
    }
}
